import React from "react";
import cx from "classnames";
import Spinner from "../../Components/Spinner";
import "./styles.css";

const VARIANTS = {
  PRIMARY: "primary",
  SECONDARY: "secondary"
};

const Button = ({
  children,
  variant,
  as = "button",
  href = null,
  type = "button",
  onClick,
  fullWidth = false,
  style,
  loading,
  disabled = false
}) => {
  const classes = cx("button-default", {
    "button-primary": variant === VARIANTS.PRIMARY,
    "button-secondary": variant === VARIANTS.SECONDARY,
    "button-fullwidth": fullWidth
  });

  const Component = as;

  return (
    <Component
      type={as === "button" ? type : null}
      href={href}
      className={classes}
      onClick={onClick}
      style={style}
      disabled={loading || disabled}
    >
      {loading && (
        <span className="spinner">
          <Spinner />
        </span>
      )}
      <span className={loading ? "button-children-loading" : undefined}>
        {children}
      </span>
    </Component>
  );
};

const PrimaryButton = ({ children, ...props }) => (
  <Button variant={VARIANTS.PRIMARY} {...props}>
    {children}
  </Button>
);

const SecondaryButton = ({ children, ...props }) => (
  <Button variant={VARIANTS.SECONDARY} {...props}>
    {children}
  </Button>
);

const PrimaryLinkButton = ({ children, ...props }) => (
  <Button variant={VARIANTS.PRIMARY} as={"a"} {...props}>
    {children}
  </Button>
);

const SecondaryLinkButton = ({ children, ...props }) => (
  <Button variant={VARIANTS.SECONDARY} as={"a"} {...props}>
    {children}
  </Button>
);

export {
  PrimaryButton,
  SecondaryButton,
  PrimaryLinkButton,
  SecondaryLinkButton
};
